import {
  PAYPAL_THEME,
  Sheet,
  ThemeWrapper,
  type SheetProps,
} from '@paypalcorp/pp-react'
import React from 'react'
import { ERROR_DISPLAY_TYPES } from '../constants'
import FullScreenError from '../screens/errors/FullScreenError'
import { useAppSelector } from '../store/hooks'
import { selectServiceErrorState } from '../store/slices/handledErrorSlice'
import SheetFooter from './SheetFooter/SheetFooter'
import { LoadingSpinner } from './LoadingSpinner/LoadingSpinner'
import PageErrorAlert from './PageErrorAlert'
import Portal from './Portal'
import { sheetFooterBlock } from './SheetWrapper.css'

type SheetWrapperProps = {
  isLoading?: boolean
} & SheetProps

const SheetWrapper: React.FC<SheetWrapperProps> = ({
  isLoading = false,
  ...props
}) => {
  const serviceError = useAppSelector(selectServiceErrorState)

  if (serviceError && serviceError.type === ERROR_DISPLAY_TYPES.FULL_SHEET) {
    return (
      <Portal>
        <Sheet {...props} center footerContents={null}>
          <FullScreenError {...serviceError} />
        </Sheet>
      </Portal>
    )
  }

  const sheetFooter =
    props.footerContents && !isLoading ? (
      <SheetFooter>{props.footerContents}</SheetFooter>
    ) : null

  const sheetContent = isLoading ? <LoadingSpinner /> : props.children

  return (
    <Portal>
      <ThemeWrapper theme={PAYPAL_THEME}>
        <Sheet
          center
          hideTitle={true}
          footerAlign="center"
          skipFormFocus={true}
          closeButtonProps={{
            'data-testid': 'close-button',
          }}
          {...props}
          footerContents={sheetFooter}
          footerClassName={sheetFooterBlock}
        >
          {!isLoading && <PageErrorAlert />}
          {sheetContent}
        </Sheet>
      </ThemeWrapper>
    </Portal>
  )
}

export default SheetWrapper
